import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Set from './containers/Set';

import { generateId } from './utils/genericUtils';
import { buildFilter } from './utils/sqlUtils';
import expressionTemplate from './defaults/expression';

import CalciteThemeProvider from 'calcite-react/CalciteThemeProvider';
import Panel from 'calcite-react/Panel';

import { isEqual } from 'lodash';

import {
  StyledSetHeaderRow
} from './containers/Set-styled';

class NarrativeFilterBuilder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mustMatchAll: true,
      sets: {
        [generateId()]: {
          mustMatchAll: true,
          expressions: {
            [generateId()]: expressionTemplate
          }
        }
      }
    };
  }

  componentDidMount() {
    if (
      this.props &&
      this.props.filterState &&
      !isEqual(this.props.filterState, this.state)
    )
      this.setState({ ...this.props.filterState }, () => {
        this.onChange(this.state);
      });
  }

  componentDidUpdate = (prevProps, prevState) => {
    // check if rehydrating from filterState
    if (
      JSON.stringify(prevProps.filterState) !==
      JSON.stringify(this.props.filterState)
    ) {
      this.setState({ ...this.props.filterState }, () => {
        this.onChange(this.state);
      });
    }
  };

  onChange = state => {
    const filter = buildFilter(state);
    this.props.onChange(filter, state);
  };

  updateSets = sets => {
    this.setState({ sets }, () => {
      this.onChange(this.state);
    });
  };

  handleAddSet = () => {
    const { sets } = this.state;
    sets[generateId()] = {
      mustMatchAll: true,
      expressions: {
        [generateId()]: expressionTemplate
      }
    };
    this.updateSets(sets);
  };

  handleRemoveSet = setId => {
    const { sets } = this.state;
    delete sets[setId];
    this.updateSets(sets);
  };

  handleUpdateSetOperator = (setId, setOperator) => {
    const { sets } = this.state;
    sets[setId].mustMatchAll = setOperator;
    this.updateSets(sets);
  };

  handleAddExpression = setId => {
    const { sets } = this.state;
    sets[setId].expressions[generateId()] = expressionTemplate;
    this.updateSets(sets);
  };

  handleRemoveExpression = (setId, expressionId) => {
    const { sets } = this.state;
    delete sets[setId].expressions[expressionId];
    this.updateSets(sets);
  };

  handleUpdateExpression = (setId, expression) => {
    const { sets } = this.state;
    const currentExpression = sets[setId].expressions[expression.id];
    sets[setId].expressions[expression.id] = {
      ...currentExpression,
      ...expression
    };
    this.updateSets(sets);
  };

  handleUpdateFilterOperator = mustMatchAll => {
    this.setState({ mustMatchAll }, () => {
      this.onChange(this.state);
    });
  };

  getSets = sets => {
    return Object.keys(sets).map(key => {
      const set = sets[key];
      return (
        <Set
          key={key}
          id={key}
          overrideStringOperators={true}
          fields={this.props.fields}
          mustMatchAll={set.mustMatchAll}
          expressions={set.expressions}
          disableUnique={this.props.disableUnique}
          updateExpression={this.handleUpdateExpression}
          onFieldChange={this.handleFieldChanged}
          onOperatorChange={this.handleOperatorChanged}
          onValueChange={this.handleValueChanged}
          updateSetOperator={this.handleUpdateSetOperator}
          canRemoveSet={false}
          addExpression={this.handleAddExpression}
          removeExpression={this.handleRemoveExpression}
        />
      );
    });
  };

  render() {

    if (!this.props.fields) {
      return null;
    }

    return (
      <CalciteThemeProvider>
        <Panel white>
          <StyledSetHeaderRow>
          </StyledSetHeaderRow>
          {this.getSets(this.state.sets)}
        </Panel>
      </CalciteThemeProvider>
    );
  }
}

NarrativeFilterBuilder.propTypes = {
  /** ArcGIS REST API or JSAPI fields definition object. */
  fields: PropTypes.object.isRequired,
  /** Object used to persist/rehydrate the filter */
  filterState: PropTypes.object,
  /** Fired when the filter changes. Receives the filter string as an argument  */
  onChange: PropTypes.func,
  /** Disables the option to pick from unique values. */
  disableUnique: PropTypes.bool
};

NarrativeFilterBuilder.defaultProps = {
  disableUnique: false
};

export default NarrativeFilterBuilder;
